// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleOrgMember = {
  id: "org-member",
  mrn: "//iam.api.mondoo.app/roles/org-member",
  title: "Org Member",
  allowedActions,
} as const;

export type RoleOrgMember = typeof roleOrgMember;
